import React from 'react';
import { Typography } from '@mui/material';
import SettingsCard from '../components/SettingsCard';

const ServerSettings = () => {
  return (
    <SettingsCard title="Servidor">
      <Typography color="text.secondary">
        Sección en desarrollo - Solo para administradores
      </Typography>
    </SettingsCard>
  );
};

export default ServerSettings;